<template>
  <v-row no-gutters class="py-3">
    <template v-for="(column, id) in columns[role][type]">
      <v-col class="py-0" cols="12" :md="column.size" :key="id">
        <v-list-item class="px-1 pb-0">
          <v-list-item-avatar v-if="column.icon" class="mr-3" color="yellow lighten-3" size="40">
            <v-icon>{{ column.icon }}</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle class="mb-0" style="line-height: 1rem">
              {{ column.title }}
            </v-list-item-subtitle>
            <template>
              <span
                class="subtitle-1"
                v-html="column.value"
                v-if="Object.keys(data).length"
                style="line-height: 1.5rem"
              ></span>
              <span class="subtitle-1 grey--text text--darken-1" v-else style="line-height: 1.5rem">
                Data {{ $titleCase(type) }} belum ada. Silakan tambahkan melalui tombol diatas jika Anda memiliki
                {{ $titleCase(type) }}
              </span>
            </template>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  name: 'PortofolioMentoring',
  props: {
    type: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => {},
    },
    role: {
      type: String,
      required: true,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    mJenjang() {
      const master = {};
      for (const item of (this.masters && this.masters.bimbingan_jenjang) || []) {
        master[item.k_profil_opsi_psp] = item.keterangan;
      }
      return master;
    },

    columns() {
      return {
        guru: {
          diklat: [
            {
              icon: 'mdi-teach',
              title: 'Nama Pelatihan',
              value: this.$getDeepObj(this.data, 'pelatihan') || '',
              size: 4,
            },
            {
              icon: 'mdi-teach',
              title: 'Penyelenggara',
              value: this.$getDeepObj(this.data, 'm_profil_opsi_psp_diklat_instansi.data.keterangan') || '',
              size: 4,
            },
            {
              title: 'tahun',
              value: this.data.tahun || '',
              size: 4,
            },
          ],
          bimbingan: [
            {
              icon: 'mdi-teach',
              title: 'Nama Program pendampingan/pembimbingan',
              value: [
                this.$getDeepObj(this.data, 'program') || '',
                `<p class="caption grey--text">
                    ${this.$durasi(
                      this.$getDeepObj(this.data, 'tahun_mulai'),
                      this.$getDeepObj(this.data, 'tahun_selesai'),
                      {
                        ignoreDate: true,
                      }
                    ) || ''}
                    </p>`,
              ].join(''),
              size: 3,
            },
            {
              title: 'Instansi yang memberikan penugasan',
              value: this.$getDeepObj(this.data, 'm_profil_opsi_psp_bimbingan_instansi.data.keterangan') || '',
              size: 3,
            },
            {
              title: 'Lingkup program ',
              value: [
                this.$getDeepObj(this.data, 'm_profil_opsi_psp_bimbingan_lingkup.data.keterangan') || '',
                `<p class="caption">
                    <span class="grey--text">Jenjang pendidikan:</span> ${this.$fkata(
                      ((this.data && this.data.jenjang) || []).map((item) => this.mJenjang[item])
                    )}
                  </p>`,
              ].join(''),
              size: 4,
            },
            {
              title: 'Lokasi Penyelenggara',
              value: this.$getDeepObj(this.data, 'm_kota_bimbingan.data.keterangan') || '',
              size: 2,
            },
            {
              title: 'Dampak dari pendampingan/pembimbingan',
              value: this.data.dampak || '',
              size: 12,
            },
          ],
          organisasi: [
            {
              icon: 'mdi-briefcase',
              title: 'Nama Organisasi',
              value: this.$getDeepObj(this.data, 'organisasi') || '',
              size: 3,
            },
            {
              title: 'Cakupan Organisasi',
              value: this.$getDeepObj(this.data, 'm_profil_opsi_psp_organisasi_lingkup.data.keterangan') || '',
              size: 2,
            },
            {
              title: 'Lama bergabung',
              value: this.$getDeepObj(this.data, 'm_profil_opsi_psp_organisasi_durasi.data.keterangan') || '',
              size: 2,
            },
            {
              title: 'Peran/Posisi',
              value: this.$getDeepObj(this.data, 'm_profil_opsi_psp_organisasi_jabatan.data.keterangan') || '',
              size: 2,
            },
            {
              title: 'Peran dalam organisasi',
              value: this.data.peran || '',
              size: 3,
            },
          ],
          organisasi_pa: [
            {
              icon: 'mdi-briefcase',
              title: 'Nama Organisasi',
              value: this.$getDeepObj(this.data, 'organisasi') || '',
              size: 3,
            },
            {
              title: 'Cakupan Organisasi',
              value: this.$getDeepObj(this.data, 'm_profil_opsi_psp_organisasi_lingkup.data.keterangan') || '',
              size: 2,
            },
            {
              title: 'Lama bergabung',
              value:
                this.$durasi(this.$getDeepObj(this.data, 'tahun_mulai'), this.$getDeepObj(this.data, 'tahun_selesai'), {
                  ignoreDate: true,
                }) || '',
              size: 2,
            },
            {
              title: 'Peran/Posisi',
              value: this.$getDeepObj(this.data, 'm_profil_opsi_psp_organisasi_jabatan.data.keterangan') || '',
              size: 2,
            },
            {
              title: 'Peran dalam organisasi',
              value: this.data.peran || '',
              size: 3,
            },
          ],
          program: [
            {
              icon: 'mdi-certificate',
              title: 'Nama Organisasi yang bekerja sama dengan Sekolah yang Anda pimpin',
              value: this.$getDeepObj(this.data, 'instansi') || '',
              size: 5,
            },
            {
              title: 'Jenis organisasi',
              value: this.$getDeepObj(this.data, 'm_profil_opsi_psp_program_instansi.data.keterangan') || '',
              size: 3,
            },
            {
              title: 'Tahun Mulai',
              value: this.$getDeepObj(this.data, 'tahun_mulai') || '',
              size: 2,
            },
            {
              title: 'Tahun Berakhir',
              value: this.$getDeepObj(this.data, 'tahun_selesai') || '',
              size: 2,
            },
          ],
          prestasi: [
            {
              icon: 'mdi-certificate',
              title: 'Nama prestasi yang Anda raih',
              value: this.$getDeepObj(this.data, 'prestasi') || '',
              size: 6,
            },
            {
              title: 'Level prestasi',
              value: this.$getDeepObj(this.data, 'm_profil_opsi_psp_prestasi_psp.data.keterangan') || '',
              size: 3,
            },
            {
              title: 'Tahun prestasi diraih',
              value: this.$getDeepObj(this.data, 'tahun') || '',
              size: 3,
            },
          ],
          komunitas: [
            {
              icon: 'mdi-certificate',
              title: 'Nama Kegiatan',
              value: this.$getDeepObj(this.data, 'kegiatan') || '',
              size: 4,
            },
            {
              title: 'Cakupan Kegiatan',
              value: this.$getDeepObj(this.data, 'm_profil_opsi_psp_komunitas_psp.data.keterangan') || '',
              size: 2,
            },
            {
              title: 'Tahun',
              value: this.$getDeepObj(this.data, 'tahun') || '',
              size: 2,
            },
            {
              title: 'Deksripsi Kegiatan',
              value: this.data.deskripsi || '',
              size: 4,
            },
          ],
          kontak: [
            {
              icon: 'mdi-certificate',
              title: 'Nama',
              value: this.$getDeepObj(this.data, 'nama') || '',
              size: 3,
            },
            {
              title: 'Hubungan dengan pemilik kontak',
              value: this.$getDeepObj(this.data, 'm_profil_opsi_psp_keluarga.data.keterangan') || '',
              size: 4,
            },
            {
              title: 'No.Telepon',
              value: this.$getDeepObj(this.data, 'no_telp') || '',
              size: 2,
            },
          ],
          hobi: [
            {
              icon: 'mdi-certificate',
              title: 'Hobi yang ditekuni',
              value: this.$getDeepObj(this.data, 'hobi') || '',
              size: 8,
            },
            {
              title: 'Lama menekuni',
              value: this.$getDeepObj(this.data, 'm_profil_opsi_psp_hobi_psp.data.keterangan') || '',
              size: 4,
            },
          ],
        },
      };
    },
  },
};
</script>

<style scoped></style>
